import { useField, useFormikContext } from 'formik';
import { CropType } from '../../../../services/entities/impl/blfApi/schemas/variety';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { VarietySelect } from '../../../settings/block/components/VarietySelect';
import { FormFieldProps } from '../generic/crud/components/GenericFormField';

type Props = {
  customerId?: string;
} & FormFieldProps;

export const VarietySelectFormField = ({ customerId, ...props }: Props) => {
  const {
    values: { cropType, customerID },
  } = useFormikContext<{ cropType: CropType; customerID?: string }>();
  const [field] = useField(props);
  const { t } = useTranslation();

  const custId = customerId ?? customerID;

  const hasRequiredDependentFieldValues = !!cropType && !!custId;

  const handleChange = (value: string) => {
    field.onChange({
      target: {
        name: field.name,
        value,
      },
    });
  };

  return (
    <VarietySelect
      customerId={customerID ?? customerId}
      value={field.value}
      onChange={handleChange}
      disabled={!hasRequiredDependentFieldValues}
      cropType={cropType}
      label={t('Select Variety')}
    />
  );
};
